import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/globals.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';

const rootElement = document.getElementById('root');

const appJsx = (
    <React.StrictMode>
        <HelmetProvider>
            <PostHogProvider
                apiKey={process.env.REACT_APP_POSTHOG_KEY}
                options={{
                    api_host: process.env.REACT_APP_POSTHOG_HOST,
                    defaults: '2025-05-24',
                    capture_exceptions: true,
                    debug: process.env.NODE_ENV === "development",
                }}
            >
                <App />
            </PostHogProvider>
        </HelmetProvider>
    </React.StrictMode>
);

// react-snap pre-renders pages to static HTML.
// If pre-rendered content exists, hydrate instead of re-rendering.
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, appJsx);
} else {
    const root = ReactDOM.createRoot(rootElement);
    root.render(appJsx);
}
